import { PayloadAction } from '@reduxjs/toolkit';
import { globalActions } from 'app/containers/Global/slice';
import { put, takeLatest } from 'redux-saga/effects';
import { localStorageEnum } from 'types';
import { seasonActions as actions } from '.';
import globalApi from '../seasonApi';
import { ISeason } from './types';

function* getSeasonsSaga(action: PayloadAction<number>) {
  try {
    const envId = action.payload;
    let selectedSeasonId = null;
    const seasons: ISeason[] = yield globalApi.getAllSeasons(envId);
    if (seasons.length) {
      const localStorageSeasonId = Number(
        localStorage.getItem(localStorageEnum.seasonId),
      );

      const localStorageSeason = seasons.find(
        season => season.id === localStorageSeasonId,
      );

      if (localStorageSeason) {
        selectedSeasonId = localStorageSeason.id;
      } else {
        const currentYear = new Date().getFullYear();
        const currentYearSeason = seasons.find(
          season => season.year === currentYear,
        );

        if (currentYearSeason) {
          selectedSeasonId = currentYearSeason.id;
        } else {
          selectedSeasonId = seasons[seasons.length - 1].id;
        }
      }
    }

    yield put(actions.setSeasons({ seasons, selectedSeasonId }));
  } catch (err) {
    yield put(globalActions.handleError(err));
  }
}
export function* seasonSaga() {
  yield takeLatest(actions.getSeasons.type, getSeasonsSaga);
}
